@if (attachment.isExpired) {
    <div class="image-expired-container" [ngClass]="{ 'border-rounded': isRoundedCorners }">
        <div class="image-expired-title">
            <span translate>The attachment has expired. </span>
            @if (permalink) {
                <span translate>Click </span>
                <a [href]="permalink" target="_blank" translate>here</a>
                <span translate> to view origin source</span>
            }
        </div>
        <img
            [src]="'./sb-tools/theme/images/broken-attachment.png'"
            class="image-expired"
            alt="broken attachment image" />
    </div>
} @else {
    @switch (attachment.attachmentType) {
        @case (attachmentTypeEnum.unknown) {}

        @case (attachmentTypeEnum.image) {
            @if (isZoomAvailable) {
                <sb-file-view-image [attachment]="attachment"></sb-file-view-image>
            } @else {
                <img
                    [src]="attachment.url"
                    class="image-preview"
                    alt="attachment image"
                    [ngClass]="{ 'border-rounded': isRoundedCorners, pointer: isFilePreviewInModal }"
                    (click)="isFilePreviewInModal ? openDocumentViewerModal($event) : false" />
            }
        }

        @case (attachmentTypeEnum.video) {
            <video width="100%" height="auto" controls [src]="attachment.url" type="video/mp4"></video>
        }

        @case (attachmentTypeEnum.iframe) {
            @if (isIframeVideo) {
                <iframe [src]="fileUrl" width="100%" height="100%" frameborder="0" allow="fullscreen" allowfullscreen>
                </iframe>
            } @else {
                <video width="100%" height="auto" controls [src]="attachment.url" type="video/mp4"></video>
            }
        }

        @case (attachmentTypeEnum.link) {
            @if (attachment.metadata) {
                <a
                    class="meta-data-container"
                    [ngClass]="{ 'link-full-width': isFullWidthView }"
                    [href]="attachment.url"
                    target="_blank">
                    @if (attachment.previewUrl || attachment.metadata.image) {
                        <img
                            [src]="attachment.previewUrl || attachment.metadata.image"
                            (error)="loadErrorImage($event)"
                            alt="link metadata image" />
                    }
                    <div class="meta-data">
                        @if (attachment.metadata.domain) {
                            <span class="meta-domain text-light truncate text-uppercase">
                                {{ attachment.metadata.domain }}
                            </span>
                        }

                        @if (attachment.metadata.title) {
                            <h4
                                class="mt-1"
                                appMultilineTruncate
                                [numberOfLines]="isFullWidthView ? 3 : 2"
                                [text]="attachment.metadata.title">
                                {{ attachment.metadata.title }}
                            </h4>
                        }
                    </div>
                </a>
            }
        }

        @case (attachmentTypeEnum.carousel) {
            @if (isGridGalleryCarousel) {
                <sb-grid-gallery
                    [attachment]="attachment"
                    [isEnablePostMessageForWidget]="isEnablePostMessageForWidget">
                </sb-grid-gallery>
            } @else {
                <carousel
                    class="carousel-container"
                    [ngClass]="{
                        'without-arrows': attachment.attachments.length <= itemsPerSlide,
                        'links-carousel': isLinksCarousel,
                        'three-items': itemsPerSlide === 3,
                        'two-items': itemsPerSlide === 2,
                    }"
                    [itemsPerSlide]="itemsPerSlide"
                    [singleSlideOffset]="isLinksCarousel"
                    [interval]="0"
                    [showIndicators]="attachment.attachments.length > itemsPerSlide"
                    [indicatorsByChunk]="true">
                    @for (slide of attachment.attachments; track slide; let index = $index) {
                        <slide>
                            <sb-file-view
                                class="carousel-slide"
                                [isCarouselItem]="true"
                                [attachment]="slide"
                                [attachments]="attachment.attachments"
                                [isFullWidthView]="true"
                                [isRoundedCorners]="false"
                                [permalink]="permalink"
                                [isFilePreviewInModal]="true"></sb-file-view>
                        </slide>
                    }
                </carousel>
            }
        }

        @default {
            @if (isMSOfficeFile) {
                <ngx-doc-viewer [viewer]="'office'" [url]="attachment.url"></ngx-doc-viewer>
            } @else {
                <div class="loader-block">
                    <sb-loader></sb-loader>
                    <span translate>
                        If you don't want to wait or have problems previewing this attachment, please
                    </span>
                    <a [href]="attachment.url" target="_blank" download="{{ attachment.name }}" translate>
                        download it to view it on your computer.</a
                    >
                </div>
                <iframe
                    id="iframe-doc-viewer"
                    (load)="processLoadedIframe()"
                    [src]="googleDocURL"
                    allow="clipboard-read; clipboard-write">
                </iframe>
            }
        }
    }
}
